module.exports = __webpack_public_path__ + "img/footer_jt.bdeaf621.svg";